import React from "react";
import { HomeGamesData } from "../../helperFunction";
import "./footer.scss";
import {
  FacebookOutlined,
  InstagramOutlined,
  LinkedinOutlined,
  TwitterOutlined,
  YoutubeOutlined,
} from "@ant-design/icons";
import { useLocation } from "react-router-dom";

const FooterAll = () => {
  const location = useLocation();
  const currentPath = location.pathname;
  const displayGameItems = HomeGamesData?.slice(0, 3);
  return (
    <section className="footer-container">
      <section className="footer-content-container">
        <ul className="footer-nav-links">
          <li className={`games ${currentPath === "/" ? "active" : ""}`}>
            <span>
              <a href="/">Home </a>
            </span>
          </li>
          <li className={`games ${currentPath === "/games" ? "active" : ""}`}>
            <span>
              <a href="/games">Games </a>
            </span>
            <ul>
              {displayGameItems?.map((e) => {
                return (
                  <li>
                    <a href={`/game-detail/${e?.id}`}>{e?.gameDesc}</a>
                  </li>
                );
              })}
              {HomeGamesData.length > 3 && (
                <li>
                  <a href="/games">more</a>
                </li>
              )}
            </ul>

            {/* <ul>
              <li>
                <a href="/games/CarMechanicSimulatorMobile">
                  Car Mechanic Simulator
                </a>
              </li>

              <li>
                <a href="/games/timberman-2-vs-battle">
                  Timberman 2 - VS Battle
                </a>
              </li>

              <li>
                <a href="/games/SupermarketManagerSimulator">
                  Supermarket Manager Simulator
                </a>
              </li>

              <li>
                <a href="/games">more</a>
              </li>
            </ul> */}
          </li>
          <li
            className={`games ${currentPath === "/about-us" ? "active" : ""}`}
          >
            <span>
              <a href="/about-us">Our story </a>
            </span>
          </li>
          <li className={`games ${currentPath === "/news" ? "active" : ""}`}>
            <span>
              <a href="/news">News </a>
            </span>
          </li>
          <li
            className={`games ${currentPath === "/developers" ? "active" : ""}`}
          >
            <span>
              <a href="/developers">Developers </a>
            </span>
          </li>
          <li className={`games ${currentPath === "/support" ? "active" : ""}`}>
            <span>
              <a href="/support">Support </a>
            </span>

            <ul>
              <li>
                <a href="/support">Privacy Policy</a>
              </li>

              {/* <li>
                <a href="/inwestorzy/terms_of_service">Terms Of Service</a>
              </li>

              <li>
                <a href="/inwestorzy/faq">FAQ</a>
              </li> */}
            </ul>
          </li>
          <li className={`games ${currentPath === "/contact" ? "active" : ""}`}>
            <span>
              <a href="/contact">Contact </a>
            </span>

            <ul>
              <li>
                <a href="/careers">Careers</a>
              </li>
            </ul>
          </li>
        </ul>
      </section>
      <div className="lower-footer-section">
        <div className="copy-rights">
          <span>
            {" "}
            © 2024-2026{" "}
            <a href="/" className="bold">
              ShiftedPixel
            </a>
            .
          </span>{" "}
          <span>All rights reserved.</span>
          <span className="app-version">v33</span>
        </div>
        <div className="social-icons">
          <a href="https://linkedin.com/company/shiftedpixel" target="_blank">
            <LinkedinOutlined />
          </a>
          <a href="https://www.instagram.com/shifted.pixel" target="_blank">
            <InstagramOutlined />
          </a>
          <a href="https://www.youtube.com/@ShiftedPixel" target="_blank">
            <YoutubeOutlined />
          </a>
        </div>
      </div>
    </section>
  );
};

export default FooterAll;
